import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";

export const UpRightArrowIcon = (props: IconProps) => (
  <Icon viewBox="0 0 12 12" fill="none" {...props} color={props.color || "currentColor"}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.76517 3.23483C8.91161 3.38128 8.91161 3.61872 8.76517 3.76517L3.26517 9.26517C3.11872 9.41161 2.88128 9.41161 2.73483 9.26517C2.58839 9.11872 2.58839 8.88128 2.73483 8.73484L8.23484 3.23483C8.38128 3.08839 8.61872 3.08839 8.76517 3.23483Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.62442 3.37559C8.5897 3.37503 8.54954 3.37501 8.5 3.37501H5.5C5.29289 3.37501 5.125 3.20712 5.125 3.00001C5.125 2.7929 5.29289 2.62501 5.5 2.62501H8.5C8.50571 2.62501 8.51145 2.62501 8.51722 2.625C8.61978 2.62496 8.73068 2.62492 8.82429 2.63751C8.93395 2.65225 9.07404 2.69017 9.19194 2.80807C9.30984 2.92597 9.34776 3.06606 9.3625 3.17572C9.37509 3.26933 9.37505 3.38023 9.37501 3.48279C9.375 3.48856 9.375 3.4943 9.375 3.50001V6.50001C9.375 6.70712 9.20711 6.87501 9 6.87501C8.79289 6.87501 8.625 6.70712 8.625 6.50001V3.50001C8.625 3.45047 8.62498 3.41031 8.62442 3.37559Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
